import { render, staticRenderFns } from "./AdminApp.vue?vue&type=template&id=4e4c3b34&scoped=true&"
import script from "./AdminApp.vue?vue&type=script&lang=js&"
export * from "./AdminApp.vue?vue&type=script&lang=js&"
import style0 from "./AdminApp.vue?vue&type=style&index=0&id=4e4c3b34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4c3b34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
